"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SourceChip;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const AppText_1 = require("../AppText");
const utils_1 = require("../../helper/utils");
const colors_1 = require("../../common/colors");
const IconOnSteroid_1 = __importDefault(require("../IconOnSteroid"));
const KNOWN_EXTENSIONS = ['pdf', 'csv', 'txt'];
;
function SourceChip({ source, displayName, freeText, onClose }) {
    const Icon = (0, react_1.useCallback)(() => {
        if (source instanceof File
            || KNOWN_EXTENSIONS.some((extension) => source.endsWith(extension))) {
            switch (source instanceof File ? source.type : (0, utils_1.getFileUrlExtension)(source)) {
                case 'text/plain':
                case 'txt':
                    return (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faAlignLeft, size: 16, gradientColors: ["#F45C06", "#FFA800"] });
                case 'text/csv':
                case 'csv':
                    return (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faTable, size: 16, gradientColors: ["#147F2C", "#B3B700"] });
                default:
                    return (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faFileLines, size: 16, gradientColors: ["#8B7BF5", "#6FA2FF"] });
            }
        }
        if (freeText) {
            return (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faText, size: 16, gradientColors: ["#7371EF", "#ED92F0"] });
        }
        if ((0, utils_1.checkYoutubeUrl)(source)) {
            return (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faVideo, size: 16, gradientColors: ["#B31217", "#F3017E"] });
        }
        ;
        if ((0, utils_1.checkValidUrl)(source)) {
            return (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faLinkSimple, size: 16, gradientColors: ["#7AAAF4", "#68DAC0"] });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }, [source, freeText]);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsx)(Icon, {}), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { numberOfLines: 1, style: styles.text, children: source instanceof File ? source.name : displayName ?? source }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: onClose, style: styles.closeContainer, children: (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_regular_svg_icons_1.faClose, size: 16, gradientColors: ['rgba(255, 255, 255, 0.56)', 'rgba(255, 255, 255, 0.56)'] }) })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        maxWidth: 176,
        backgroundColor: `${colors_1.Colors.DARK_300}3D`,
        gap: 8,
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'flex-start',
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 5,
    },
    text: {
        color: colors_1.Colors.NEUTRAL_00,
        fontSize: 12,
        fontWeight: '400',
        lineHeight: 16,
    },
    closeContainer: {
        width: 12,
        height: 16,
        justifyContent: 'center',
        alignItems: 'center',
    }
});
